import { executeGetRequest } from "@api/client";
import { apiPath } from "@routes/api";

export const getImages = async (lang: string) => {
  const [promise] = executeGetRequest(apiPath.images, lang);
  const result: any = await promise;
  return result.data;
};
